<!-- Elevate AI chat widget (testbed). The wrapping div carries the *ngIf so the flag can be
     toggled without touching the layout below. The launcher positions itself fixed bottom-right.
     Attributes only - see initAiChatWidget() in app.component.ts. `token` is set imperatively. -->
<div *ngIf="aiChatEnabled">
    <elevate-chat-launcher
        server-url="{{ aiChatServerUrl }}"
        label="Ask Elevate AI"
        heading="Elevate AI Support"
        position="bottom-right">
    </elevate-chat-launcher>
</div>

<div [ngClass]="{'subscription-bar-visible': subscriptionStatusBarVisible()}">
    <theme3-layout *ngIf="theme=='theme3'"></theme3-layout>
</div>

<!--<loginAttemptsModal #loginAttemptsModal></loginAttemptsModal>
<linkedAccountsModal *ngIf="!installationMode" #linkedAccountsModal (modalClose)="getRecentlyLinkedUsers()"></linkedAccountsModal>-->
<!--<userDelegationsModal #userDelegationsModal></userDelegationsModal>-->
<changePasswordModal #changePasswordModal></changePasswordModal>
<changeProfilePictureModal #changeProfilePictureModal></changeProfilePictureModal>
<mySettingsModal #mySettingsModal (modalSave)="onMySettingsModalSaved()"></mySettingsModal>
<notificationSettingsModal #notificationSettingsModal></notificationSettingsModal>

<!--<commonLookupModal #userLookupModal (itemSelected)="chatBarComponent.addFriendSelected($event)"></commonLookupModal>
<chat-bar #chatBarComponent *ngIf="!installationMode" [userLookupModal]="userLookupModal"></chat-bar>-->
<!--<theme-selection-panel #themeSelectionPanelComponent *ngIf="!installationMode && isQuickThemeSelectEnabled"></theme-selection-panel>-->
<session-timeout #sessionTimeout *ngIf="IsSessionTimeOutEnabled"></session-timeout>